import { fetcher } from "utils";

export const post__help__new_store = (name: string) => fetcher.post("/help/new_store", { name });
